import React from "react";
import {cn} from "../utils";

const AddVideoIcon = (
    {
        className,
        color
    }: {
        className?: string,
        color?: string
    } & React.SVGProps<SVGSVGElement>) => (
    <svg fill="none"
         height="512"
         width="512"
         viewBox="0 0 24 24"
         className={cn(className)}
         xmlns="http://www.w3.org/2000/svg">
        <path clipRule="evenodd"
              d="m9.98974 1.25008h-3.98974c-2.62335 0-4.75 2.12665-4.75 4.75v12.00002c0 2.6233 2.12665 4.75 4.75 4.75h12c2.6234 0 4.75-2.1267 4.75-4.75v-12.00002c0-2.62335-2.1266-4.75-4.75-4.75h-7.9884c-.0073-.00011-.01456-.00011-.02186 0zm-1.39113 1.5h-2.59861c-1.79493 0-3.25 1.45507-3.25 3.25v1.25h2.84861zm-1.19722 4.5 3.00001-4.5h6.1972l-3 4.5zm-1.41303 1.5c.00731.00011.0146.00011.0219 0h7.97814c.0073.00011.0146.00011.0219 0h7.2397v9.25002c0 1.7949-1.4551 3.25-3.25 3.25h-12c-1.79493 0-3.25-1.4551-3.25-3.25v-9.25002zm15.26164-1.5v-1.25c0-1.66423-1.2509-3.0363-2.8638-3.22729l-2.9848 4.47729zm-9.25 4.00002c.4142 0 .75.3358.75.75v2.25h2.25c.4142 0 .75.3358.75.75s-.3358.75-.75.75h-2.25v2.25c0 .4142-.3358.75-.75.75s-.75-.3358-.75-.75v-2.25h-2.25c-.41421 0-.75-.3358-.75-.75s.33579-.75.75-.75h2.25v-2.25c0-.4142.3358-.75.75-.75z"
              fill={color || "currentColor"}
              fillRule="evenodd"
        />
    </svg>
);

export {AddVideoIcon};